import clsx from 'clsx'
import React, { CSSProperties, ReactNode, useState } from 'react'

import s from './styles.module.scss'

export interface TooltipProps {
  children: ReactNode
  className?: string
  content: ReactNode
  contentClassName?: string
  position?:
    | 'top'
    | 'bottom'
    | 'left'
    | 'right'
    | 'top-left'
    | 'top-right'
    | 'bottom-left'
    | 'bottom-right'
    | 'center'
  disable?: boolean
  style?: CSSProperties
  contentStyle?: CSSProperties
}

export const Tooltip = ({
  children,
  className,
  content,
  contentClassName,
  position = 'top',
  disable = false,
  style,
  contentStyle,
}: TooltipProps) => {
  const [displayTooltip, setDisplayTooltip] = useState<boolean>(false)

  return (
    <div
      className={clsx(className, s.tooltipContainer)}
      onMouseOver={() => setDisplayTooltip(true)}
      onMouseOut={() => setDisplayTooltip(false)}
      style={style}
    >
      {children}

      {displayTooltip && !disable ? (
        <div
          className={clsx(s.tooltip, contentClassName, s[position])}
          style={contentStyle}
        >
          {content}
        </div>
      ) : null}
    </div>
  )
}
